export enum BlockType {
  Text = 'text',
  Image = 'image',
  Space = 'space',
  Button = 'button',
  Social = 'social',
  Survey = 'survey',
  Divider = 'divider',
}
